import {Component, Input, OnInit} from '@angular/core';
import {FoEventsService} from "../foevents.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-pricing-header',
  templateUrl: './pricing-header.component.html',
  styleUrls: ['./pricing-header.component.css']
})
export class PricingHeaderComponent implements OnInit {
  @Input() pricing: any;
  @Input() isFrame: boolean = false;
  @Input() front_event:any;

  constructor() { }

  ngOnInit() {

  }

  nbPlace(pricing) {

    if (pricing.Totalplace && pricing.Totalplace > 0 && pricing.ShowNbPlace) {
      return pricing.Totalplace + ' ' + this.front_event.remainings_tickets;
    }
    else if (pricing.Totalplace && pricing.Totalplace == 0 && pricing.ShowNbPlace) {
      return this.front_event.sold_out;
    }
    else if (pricing.Totalplace == -1 && pricing.ShowNbPlace) {
      return this.front_event.unlimited_number_of_place;
    }
  }
}
